// extracted by mini-css-extract-plugin
export var aircallIframe = "_bv-3";
export var fabContainer = "_bv-5";
export var fabRinging = "_bv-6";
export var loadingOverlay = "_bv-4";
export var pulse = "_bv-7";
export var widgetContent = "_bv-2";
export var widgetPanel = "_bv-0";
export var widgetPanelExpanded = "_bv-1";